import api from './api.service';

function request(email) {
  return api.post('/password', {
    email,
  });
}

function reset(params) {
  return api.put('/password', params);
}

function change(params) {
  return api.post('/password/change', params);
}

export const passwordService = {
  request,
  reset,
  change,
};
